import { ClerkProvider } from "@clerk/react";
import { dark } from "@clerk/ui/themes";
import { CssBaseline, GlobalStyles, useColorScheme } from "@mui/material";
import { QueryClientProvider } from "@tanstack/react-query";
import { SnackbarProvider } from "notistack";
import type { ReactNode } from "react";
import { LocalizationProvider } from "@/components/core/localization-provider";
import { queryClient } from "@/helpers/tanstack-client";
import { PreviewProvider } from "@/hooks/preview";

const clerkLocalization = {
  signUp: {
    start: {
      title: "Welcome to {{applicationName}}!",
      subtitle: "Create your account.",
    },
  },
  organizationList: {
    createOrganization: "What's your company called?",
    action__createOrganization: "Continue",
    titleWithoutPersonal: "Choose organization",
  },
  createOrganization: {
    formButtonSubmit: "Continue",
  },
};

export const AppProviders = ({ children }: { children: ReactNode }) => {
  const { mode, systemMode } = useColorScheme();

  return (
    <ClerkProvider
      appearance={{
        theme: mode == "dark" || (mode == "system" && systemMode == "dark") ? dark : undefined,
      }}
      publishableKey={import.meta.env.VITE_CLERK_PUBLISHABLE_KEY}
      signInUrl="/signin"
      signUpUrl="/signup"
      afterSignOutUrl="/"
      localization={clerkLocalization}
    >
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider>
          <CssBaseline />
          <GlobalStyles
            styles={{
              body: {
                "--SideNav-width": "170px",
              },
            }}
          />
          <PreviewProvider>{children}</PreviewProvider>
          <SnackbarProvider />
        </LocalizationProvider>
      </QueryClientProvider>
    </ClerkProvider>
  );
};
